/*
 * This carousel is a combination of two CSS carousels:
 * 1. https://codepen.io/dbj/details/XNmvYo
 * This is the default presentation. It has no interaction and supports wrap-around animation
 * 2. https://schepp.dev/posts/css-only-carousel/
 * This is used at a smaller breakpoint when the `responsive` property has been set.
 * It has no wrap-around but allows manual scrolling.
 */

import { RenderResult } from '@dojo/framework/core/interfaces';
import { create, tsx } from '@dojo/framework/core/vdom';

import * as css from './Carousel.m.css';

export interface CarouselProps {
	responsive?: boolean;
}

const factory = create().children<RenderResult[]>().properties<CarouselProps>();

/*
This carousel currently only supports exactly 3 or 4 slides. Support for more can be added by
defining relevant keyframes in the CSS module and updating the logic in this module to assign
the correct CSS class to the css.viewport node.
 */
export const Carousel = factory(function Carousel({ children, properties }) {
	const slides = children();
	const { responsive } = properties();

	return (
		<div classes={[css.root, responsive && css.responsive]}>
			<ul classes={[css.viewport, slides.length === 3 ? css.threeSlides : css.fourSlides]}>
				{slides.map((slide) => (
					<li classes={css.slide}>
						<div classes={css.snapper} />
						{slide}
					</li>
				))}
			</ul>
		</div>
	);
});
